import { useState } from "react"
import AddLessonForm from "./AddLessonForm"
import AddLessonButton from "./AddLessonButton"

function AddLessonHandler({ createHandler }) {
    const [ active, setActive ] = useState(false)

    const handleOpen = async (e) => {
        e.preventDefault()
        setActive(true)
    }

    const handleClose = async (e) => {
        e.preventDefault()
        setActive(false)
    }

    return <>{ 
        active
            ? <AddLessonForm clickHandler={handleClose} createHandler={createHandler} />
            : null
    }
    <AddLessonButton clickHandler={handleOpen}/>
    </>
}

export default AddLessonHandler